import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import {
  DistrictDTO,
  DistrictKnowledgeBaseAPIResponse,
} from 'src/app/common/dtos/district.dto';
import { User } from 'src/app/common/state/user/user.model';
import { UserState } from 'src/app/common/state/user/user.state';
import { DistrictListService } from 'src/app/private/shared/services/district-list/district-list-service';
import { GlaiKnowledgebaseService } from 'src/app/private/shared/services/glai/glai-knowledgebase.service';
import { AlertService } from '../../shared/services/alert/alert.service';

@Component({
  selector: 'app-ai-page',
  standalone: false,
  templateUrl: './ai-page.component.html',
  styleUrl: './ai-page.component.scss',
})
export class AiPageComponent implements OnInit {
  isLoading = true;

  kbIsLoading = true;

  district: DistrictDTO;

  districtCode: string;

  districtKnowledgeBase: DistrictKnowledgeBaseAPIResponse;

  user: User | null;

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private store: Store,
    private glaiKnowledgebaseService: GlaiKnowledgebaseService,
    private districtList: DistrictListService,
    private alertService: AlertService
  ) {
    this.user = this.store.selectSnapshot(UserState.getUser);
  }

  ngOnInit(): void {
    this.districtCode = this.route.snapshot.paramMap.get(
      'districtCode'
    ) as string;
    this.districtList
      .fetchDistrictsSimple({ per_page: 1000 })
      .subscribe((districts) => {
        if (districts) {
          const district = districts.find(
            (searchDistrict) =>
              searchDistrict.districtCode === this.districtCode
          ) as DistrictDTO;
          if (district) {
            this.district = district;
            this.isLoading = false;
            this.getDistrictKnowledgeBase(this.district.id);
          }
        }
      });
  }

  getDistrictKnowledgeBase(districtId: number) {
    this.glaiKnowledgebaseService
      .getDistrictKnowledgeBase(districtId)
      .subscribe({
        next: (response) => {
          this.districtKnowledgeBase = response?.item ?? null;
          this.kbIsLoading = false;
        },
        error: (err: HttpErrorResponse) => {
          if (err.status !== 404) {
            this.alertService.showAlert('Error loading knowledge base');
          }
          this.kbIsLoading = false;
        },
      });
  }
}
